import { Modal, Typography, Grid } from 'antd';
import { useTranslation } from 'react-i18next';
const { Text } = Typography;
const { useBreakpoint } = Grid;
import Close from 'assets/images/liHome/close.svg';

interface ModalProps {
  isModalVisible: boolean;
  handleModalClose: () => void;
  title: string;
  handleModalOk: () => void;
  desc?: string;
  OkContent?: string;
  cancelContent?: string;
}

function ConfirmModal(props: ModalProps) {
  const { t } = useTranslation();
  const { lg } = useBreakpoint();

  return (
    <Modal
      open={props.isModalVisible}
      onCancel={props.handleModalClose}
      width={510}
      onOk={props.handleModalOk}
      okText={props.OkContent ? props.OkContent : t('common.yes')}
      cancelText={props.cancelContent ? props.cancelContent : t('common.no')}
      className="e-notice-modal"
      closeIcon={<img src={Close} />}
      bodyStyle={{ padding: '8px', width: '100%' }}
    >
      <div style={{ width: 'calc(100% - 54px)' }}>
        <p
          style={{
            padding: '0 12px',
            paddingRight: '0',
            lineHeight: '29px',
            fontFamily: 'Roboto400',
            marginBottom: '16px',
          }}
          className={`red-font ${lg ? 'font-size26' : 'font-size22'}`}
        >
          {props.title}
        </p>
      </div>
      {props.desc && (
        <Text
          className="font-size17"
          style={{
            padding: '0px 12px',
            width: '100%',
            display: 'inline-block',
            fontFamily: 'Roboto400',
            color: '#20252b',
            lineHeight: '22px',
          }}
        >
          {props.desc}
        </Text>
      )}
    </Modal>
  );
}

export default ConfirmModal;
